// extracted by mini-css-extract-plugin
export var link = "ContactLink-module--link--JlUe5";
export var icon = "ContactLink-module--icon--eOAcX";
export var text = "ContactLink-module--text--qOB0x";